<style lang="scss">
.tabs {
  display: flex;
  margin-top: 20px;
  button {
    padding: 23px 10px !important;
  }

  .active {
    background-color: $c-blue !important;
    color: $c-white !important;
    border-color: $c-blue !important;
  }
}
</style>

<template>
  <div class="tabs">
    <button @click="navigate({ name: 'OverviewPersonal', params: { id } })" :class="{ active: active == 'data' }">Skillübersicht</button>
    <button @click="navigate({ name: 'OverviewPersonalGrading', params: { id } })" :class="{ active: active == 'grading' }">
      Mitarbeiter:innengespräch
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  props: {
    active: { type: String as PropType<'data' | 'grading'>, default: 'data' },
  },
  setup() {
    const router = useRouter();
    const id = router.currentRoute.value.params.id as string;

    return {
      navigate: router.push,
      id,
    };
  },
});
</script>
